import ListaPreciosVentaList from "./ListaPreciosVentaList.vue";
export default ListaPreciosVentaList;
